import { useAppSelector } from '@/store';
import { selectCurrentUserId } from '@/store/selectors/auth';
import { selectFileCloneErrorMap, selectFileCloneStatusMap } from '@/store/selectors/poc/cloneStatusSelectors';
import type { FileEntry } from '@/types/SixDetail.types';
import type { FileCloneStatus } from '@/types/poc/helia';
import { canDownloadFile, userHasFileKey } from '@/utils/fileAccess.utils';

export function useFileCloneStatus(file: FileEntry): FileCloneStatus {
  const cid = file.cid ?? '';
  const rawStatus = useAppSelector((state) => selectFileCloneStatusMap(state)[cid] ?? 'unknown');
  const currentUserId = useAppSelector(selectCurrentUserId);

  if (canDownloadFile(file) && !userHasFileKey(file, currentUserId)) {
    return 'no-access';
  }

  return rawStatus;
}

export function useFileCloneError(cid?: string): string | undefined {
  return useAppSelector((state) => {
    if (typeof cid !== 'string' || cid.length === 0) return undefined;
    return selectFileCloneErrorMap(state)[cid];
  });
}

export function useFileCanDownload(file: FileEntry): boolean {
  const currentUserId = useAppSelector(selectCurrentUserId);

  if (!canDownloadFile(file)) return false;

  return userHasFileKey(file, currentUserId);
}
